export const SET_MEMBERSHIP_DATA = 'SET_MEMBERSHIP_DATA';
export const SET_SINGLE_MEMBERSHIP_DATA = 'SET_SINGLE_MEMBERSHIP_DATA';
export const ADD_MEMBERSHIP_DATA = 'ADD_MEMBERSHIP_DATA';
export const DELETE_MEMBERSHIP_DATA = 'DELETE_MEMBERSHIP_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/membership/action-types.js